import React from 'react';

import { ASSISTANT_TEXTS } from '../../texts';
import MessageAvatar from '../MessageAvatar';

import styles from '../../styles.module.css';

const TypingIndicator = () => (
	<div className={styles.msgRow}>
		<MessageAvatar role="assistant" />
		<div className={styles.msgContent}>
			<div className={styles.msgSender}>{ASSISTANT_TEXTS.senderName}</div>
			<div className={styles.typingDots}>
				<div className={styles.dot} />
				<div className={styles.dot} />
				<div className={styles.dot} />
			</div>
		</div>
	</div>
);

export default TypingIndicator;
